import { Card, CardContent, Typography } from "@mui/material";
import React from "react";

export default function DashboardCard(props) {
  const { children, title, subheader = "", sx, contentStyle, rest } = props;

  const cardStyle = {
    margin: "15px",
    padding: "5px",
    boxShadow: "0px 1px 1px rgba(100, 116, 139, 0.06),0px 1px 2px rgba(100, 116, 139, 0.1)",
  };

  return (
    <Card sx={{ ...cardStyle, ...sx }} {...rest}>
      <CardContent sx={{ padding: "15px" }}>
        <Typography variant="h6" component="div">
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {subheader}
        </Typography>
      </CardContent>
      <CardContent sx={{ paddingY: "10px", paddingX: "15px" }}>
        {children}
      </CardContent>
    </Card>
  );
}
